import {action, makeAutoObservable} from "mobx";
import CommonStore from "../../../stores/CommonStore";
import { SalePriceService } from "../../../service/SalePriceService";
import { CustomCategoryWeightRangeService } from "../../../service/packageDelivery/customCategory/CustomCategoryWeightRangeService";
import CustomCategoryWeightRange from "../../../model/packageDelivery/customCategory/CustomCategoryWeightRange";
import CustomCategoryWeightRangeSalePrice from "../../../model/packageDelivery/customCategory/CustomCategoryWeightRangeSalePrice";
import { CustomCategoryService } from "../../../service/packageDelivery/customCategory/CustomCategoryService";
import CustomCategory from "../../../model/packageDelivery/customCategory/CustomCategory";

class ShowPackageCustomCategoryWeightRangeCostsStore {
    public customCategoryWeinghtRangesPrices: CustomCategoryWeightRangeSalePrice[];
    public weinghtRanges: CustomCategoryWeightRange[];
    public customCategories: CustomCategory[];
    public isModalOpen: boolean;
    public loading: boolean;
    public commonStore: CommonStore;

    constructor(commonStore: CommonStore) {
        this.isModalOpen = false;
        this.customCategoryWeinghtRangesPrices = [];
        this.weinghtRanges = [];
        this.customCategories = [];
        this.loading = false;
        this.commonStore = commonStore;
        makeAutoObservable(this);
    }

    get isEmpty(): boolean {
        return this.weinghtRanges.length === 0;
    }

    @action
    public async searchCustomCategories(): Promise<void> {
        const response = await CustomCategoryService.get(1, 1000, '');
        if (response.success) {
            this.customCategories = response.data?.data || [];
            this.getCustomCategoryWeightRanges();
        }
    }

    @action
    public async getCustomCategoryWeightRanges() {
        const response = await CustomCategoryWeightRangeService.getAllFromBaseAgency();
        if (response.success && response.data) {
            this.weinghtRanges = response.data;
        }
    }

    @action
    public async loadAgencySalePrices() {
        const response = await SalePriceService.getAgencySalePrice();
        if (response.success && response.data) {
            this.customCategoryWeinghtRangesPrices = response.data.packageCustomCategoryWeightRangeSalePrices;
        }
        this.commonStore.processErrors(response);
    }

    @action
    public async openModal() {
        this.loading = true;
        await this.loadAgencySalePrices();
        await this.searchCustomCategories();
        this.isModalOpen = true;
        this.loading = false;
    }

    @action
    public closeModal() {
        this.isModalOpen = false;
    }

}

export default ShowPackageCustomCategoryWeightRangeCostsStore;